import { useSelector } from "react-redux";

function EcardIntro(props) {
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const currentPreviewState = useSelector((state) => state.cardPreview);

  const requestDetails = currentRequest.DonorRequest;
  const isIndividual = requestDetails.MassTypeValue == "individual";
  const isNovena = requestDetails.MassTypeValue == "novena";
  const isGregorian = requestDetails.MassTypeValue == "gregorian";

  let subjectLine = 'A Mass eCard from ' + requestDetails.EcardName;
  if(isNovena) {
    subjectLine = 'A Novena of Nine Masses eCard from ' + requestDetails.EcardName;
  } else if(isGregorian) {
    subjectLine = 'A Gregorian Mass eCard from ' + requestDetails.EcardName;
  }

  return (
    <div className="ecard ecard-email">
      <div className="ecard-email-header">
        <p>
          From: SMAeCards@SeraphicMass.org
          <br />
          To: {requestDetails.EcardEmail}
          <br />
          Subject: {subjectLine}
        </p>
      </div>
      <div className="ecard-email-content">
        <p>
          <button
            className="btn btn-primary btn-sm ecardLink"
            onClick={props.onClickHandler}
          >
            CLICK TO VIEW YOUR eCARD
          </button>
        </p>
        <p>
          <button className="show-ecard" onClick={props.onClickHandler}>
            <img
              id="EcardCover"
              src={currentPreviewState.SelectedCard.CoverImage}
              alt="eCard Cover"
            />
          </button>
        </p>
      </div>
      <div id="ecard-footer">
        <div className="footer-text">
          <p>This Card was sent to you from myMassRequest.org.</p>{" "}
        </div>
        <div className="blue-hr"></div>
        <div className="footer-cols">
          <div className="column-left">
            <img src="/dist/images/sma-logo.png" />
          </div>
          <div className="column-center">
            <div className="column-content">
              <p>
                <em>Seraphic Mass Association</em>
                <br />
                5217 Butler St. Ste. 100
                <br />
                Pittsburgh PA 15201-2657
              </p>
            </div>
          </div>
          <div className="column-right">
            <div className="column-content">
              <p>Call: (412) 683-4700</p>
              <p>or 1 (877) 737-9050</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EcardIntro;
